import React, { Component } from 'react';
import moment from 'moment-timezone';
import * as $ from 'jquery';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import BalanceContainer from './BalanceContainer.js'
import axios from 'axios';
import brandLogo from '../../images/cowork.jpeg';
import LogoBATCH from '../../images/brand-logo-dark-cropped.png'
import MarketplaceContainer from './MarketplaceContainer.js'
import { Link } from 'react-router-dom';

let cancelToken;
let state;
let tokenSession;


class Profile extends Component {

    getInitState = () => {
        return {
            profile: null,
            balance: []
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        this.getProfile({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });
    }

    getProfile = (params) => {
        this.props.post(
            "/getProfileUser",
            params,
            (response) => this.didGetProfile(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }


    getHours = (params) => {
        this.props.post(
            "/gethours",
            params,
            (response) => this.didGetHours(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    getProfileUpdatePublic = (params) => {
        this.props.post(
            "/updatePublicProfile",
            params,
            (response) => this.handleProfileUpdatePrivate(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getProfileUpdatePrivate = (params) => {
        this.props.post(
            "/updatePrivateProfile",
            params,
            (response) => this.handleProfileUpdatePublic(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetProfile = (response) => {
        this.setState({ profile: response })
        this.getHours({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            empresa_id: response.empresa_id
        });
    }

    didGetHours = (response) => {
        this.setState({
            balance: response
        })
    }

    handleErrorResponse = (error) => {
        alert(error)
    }

    handleProfileUpdatePrivate = (response) => {
        const { t } = this.props;
        alert(t('dashboard.conecctions.public'))
        this.reload();
    }

    UpdateProfilePrivate = () => {
        this.getProfileUpdatePrivate({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });
    }

    handleProfileUpdatePublic = (response) => {
        const { t } = this.props;
        alert(t('dashboard.conecctions.private'))
        this.reload();
    }

    UpdateProfilePublic = () => {
        this.getProfileUpdatePublic({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        });
    }


    handleProfilePicture = (event) => {
        const params = new FormData();
        params.append("picture", event.target.files[0]);
        params.append("token_id", this.props.getTokenId());
        params.append("token_session", this.props.getTokenSession());
        this.profilePicture(params);
    }

    profilePicture = (params) => {
        this.props.post(
            "/profilePicture",
            params,
            this.reload,
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }


    handleProfilePicturePortada = (event) => {
        const params = new FormData();
        params.append("picture", event.target.files[0]);
        params.append("token_id", this.props.getTokenId());
        params.append("token_session", this.props.getTokenSession());
        this.profilePicturePortada(params);
    }

    profilePicturePortada = (params) => {
        this.props.post(
            "/profilePortada",
            params,
            this.reload,
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    renderBalance = () => {
        return (
            <BalanceContainer
                balance={this.state.profile.balance}
                new_balance={this.state.balance}
            />
        )
    }

    renderMarketplaceContainer = () => {
        return (
            <MarketplaceContainer
                getTokenId={this.props.getTokenId}
                getTokenSession={this.props.getTokenSession}
                handleErrorResponse={this.props.handleErrorResponse}
                post={this.props.post}
                user={this.props.user} />
        );
    }

    render() {
        const { t } = this.props;
        const profile = this.state.profile;
        if (!profile) return null

        const date_created = new Date(profile.created);
        const date_created_format = `${String(date_created.getMonth() + 1).padStart(2, '0')} / ${date_created.getFullYear()}`
        const background = profile.portada ? profile.portada : brandLogo;

        return (
            <div className="content-profile">
                <div className="container-profile">
                    <div className="panel card">
                        <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + background + "')" }}>
                            <a onClick={() => $('#chooserProfilePortada').click()}>
                                <button className="change_portada">
                                    <i className="fa fa-camera" aria-hidden="false"></i>
                                </button>
                            </a>
                        </div>

                        <div className="card-panel-body">
                            <div className="profile">
                                <a onClick={() => $('#chooserProfile').click()}>
                                    <div className="badge-wrapper">
                                        <img
                                            className="cover-img__image relative w-full h-full object-cover img-responsive"
                                            alt={t('dashboard.profile.img_user')}
                                            src={profile.picture}
                                            loading="lazy" data-embed-id="cover-image" />
                                    </div>
                                </a>
                            </div>
                            <div className="profile-description">
                                <div className="user-data">
                                    <h5 className='second-span'># {profile.user_id}</h5>
                                    <h4 className="subspan">
                                        {profile.name + " " + profile.lastname} 
                                    </h4>
                                    {
                                        (profile.position && profile.company) && (
                                            <h4 className='second-span'>{profile.position} @ {profile.company}</h4>
                                        )
                                    }
                                    <div>
                                        {profile.center && (
                                            <h4 className='ioscentro'>
                                                {profile.center.center_name}
                                            </h4>
                                        )}
                                    </div>
                                    <div className="user-description" style={{ textAlign: "left" }}>
                                        {profile.description}
                                    </div>
                                </div>
                                <div className="user-work-data-informacion">
                                    <h4>Información de la cuenta</h4>
                                    <section className="user-work-data">
                                        <i className="fa-regular fa-envelope"></i>
                                        <p>{profile.email ? profile.email : "No proporcionado"}</p>
                                    </section>
                                    <section className="user-work-data">
                                        <i className="fa-solid fa-phone"></i>
                                        <p>{profile.phone ? profile.phone : "No proporcionado"}</p>
                                    </section>
                                    {
                                        profile.business_name && (
                                            <section className="user-work-data">
                                                <i className="fa-regular fa-building"></i>
                                                <p>{profile.business_name}</p>
                                            </section>
                                        )
                                    }
                                    {
                                        profile.member_id && profile.perfil_publico === "1" ? (
                                            <section className="user-work-data">
                                                <i className="fa-solid fa-id-badge"></i>
                                                <p>{t('dashboard.conecctions.public')}</p>
                                            </section>
                                        ) : (
                                            <section className="user-work-data">
                                                <i className="fa-solid fa-id-badge"></i>
                                                <p>{t('dashboard.conecctions.private')}</p>
                                            </section>
                                        )
                                    }
                                    {profile.position ? (
                                        <div className="user-work-data">
                                            <div className="profile-company">
                                                <img className="cover-img__image relative w-full h-full object-cover img-responsive"
                                                    src={profile.company_picture}
                                                    loading="lazy" data-embed-id="cover-image" alt="" />
                                            </div>
                                            <div className="profile-company-name">
                                                <h4 className="company-name">{profile.company ? profile.company : "company"}</h4>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="user-work-data-informacion">
                                    <h4>Información de Contacto</h4>
                                    {
                                        profile.contact_email && (
                                            <section className="user-work-data">
                                                <i className="fa-solid fa-at"></i>
                                                <p>{profile.contact_email}</p>
                                            </section>
                                        )
                                    }
                                    <div className="user-work-data">
                                        <i className="fa fa-facebook-official" aria-hidden="true"></i>
                                        <Link className="img-responsive redes" to={
                                            profile.perfil_facebook ? profile.perfil_facebook : "/profile/edit/user"
                                        }>
                                            <p>
                                                {profile.perfil_facebook ? profile.perfil_facebook : "No proporcionado"}
                                            </p>
                                        </Link>
                                    </div>
                                
                                    <div className="user-work-data">
                                        <i className="fa fa-instagram"></i>
                                        <Link className="img-responsive redes" to={
                                            profile.perfil_instragram ? profile.perfil_instragram : "/profile/edit/user"
                                        }>
                                            <p>
                                                {profile.perfil_instragram ? profile.perfil_instragram : "No proporcionado"}
                                            </p>
                                        </Link>
                                    </div>
                                   
                                    <div className="user-work-data">
                                        <i className="fa fa-linkedin"></i>
                                        <Link className="img-responsive redes" to={
                                            profile.perfil_Linkedin ? profile.perfil_Linkedin : "/profile/edit/user"
                                        }>
                                            <p>
                                                {profile.perfil_Linkedin ? profile.perfil_Linkedin : "No proporcionado"}
                                            </p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="profile-contact">

                                <div>
                                    {profile.member_id
                                        ? (
                                            <button type="button" className="btn btn-primary visible-xs" data-toggle="modal" data-target=".bs-example-modal-sm" style={{ margin: "5px" }}>
                                                BADGE DIGITAL
                                            </button>
                                        ) : null}
                                </div>
                                <div className="" role="group">
                                    {profile.member_id ? (
                                        profile.perfil_publico === "1" ? (
                                            <button type="button" className="btn btn-default" onClick={this.UpdateProfilePrivate}>
                                                {t('dashboard.conecctions.make_private')}
                                            </button>
                                        ) : (
                                            <button type="button" className="btn btn-default" onClick={this.UpdateProfilePublic}>
                                                {t('dashboard.conecctions.make_public')}
                                            </button>
                                        )
                                    ) : null}
                                    <Link to="/profile/edit/user" className="btn btn-primary">
                                        Editar Informacion Personal
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={profile.member_id ? "container-room-description" : "container-room-description hidden "}>
                        <div className="profile-balance">
                            {profile.member_id
                                ? (
                                    this.renderBalance()
                                )
                                : null}
                        </div>
                        <div className="profile_markrplace">
                            {profile.member_id
                                ? (
                                    this.renderMarketplaceContainer()
                                )
                                : null}
                        </div>
                    </div>
                    <div>
                        <input
                            className="hidden"
                            id="chooserProfile"
                            onChange={this.handleProfilePicture}
                            type="file" />
                        <input
                            className="hidden"
                            id="chooserProfilePortada"
                            onChange={this.handleProfilePicturePortada}
                            type="file" />

                    </div>
                    <div className="modal fade bs-example-modal-sm" tabIndex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
                        <div className="modal-dialog modal-sm" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button id="modal_colosepayment" type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;
                                        </span>
                                    </button>
                                    <h4 className="modal-title" id="mySmallModalLabel">
                                        BADGE DIGITAL
                                    </h4>
                                </div>
                                <div className="modal-body badge-digital">
                                    <img
                                        className="img-responsive"
                                        alt={t('dashboard.profile.img_user')}
                                        src={LogoBATCH}
                                        loading="lazy" data-embed-id="cover-image" />
                                    <div className="badge-wrapper">
                                        <img
                                            className="img-responsive"
                                            alt={t('dashboard.profile.img_user')}
                                            src={profile.picture}
                                            loading="lazy" data-embed-id="cover-image" />
                                    </div>
                                    <h4>{profile.name + " " + profile.lastname}</h4>
                                    <div style={{ margin: '30px 0px' }}>
                                        <div className="" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <div>
                                                <h4><span className="ioscentro">ID SOCIO:</span> {profile.empresas_numero}</h4>
                                            </div>
                                            <div>
                                                <h4><span className="ioscentro">DESDE:</span> {date_created_format}</h4>
                                            </div>
                                        </div>
                                        <h4 className="ioscentro">{profile.center_name}</h4>
                                    </div>
                                    <h4>SUPERA TUS SUEÑOS</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    translate('common'),
    withRouter
)(Profile);



// WEBPACK FOOTER //
// ./src/dashboard/mainPage/Profile.js